import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { parse as parseQs } from "qs";
import * as React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { DispatchListUrlQueryParams } from "./url";
import BatchAssignmentListComponent from "./views/BatchAssignmentList";
import DispatchHistoryComponent from "./views/DispatchHistory";
import TripInformationComponent from "./views/TripInformation";

const BatchAssignmentList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: DispatchListUrlQueryParams = qs;

  return <BatchAssignmentListComponent params={params} />;
};

const DispatchHistory: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substring(1));
  const params: DispatchListUrlQueryParams = qs;

  return <DispatchHistoryComponent params={params} />;
};

const TripInformation: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substring(1));
  const params: DispatchListUrlQueryParams = qs;

  return (
    <TripInformationComponent params={params} id={decodeURIComponent(id)} />
  );
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.dispatch)} />
      <Routes>
        <Route path={"batch-assignment"} element={<BatchAssignmentList />} />
        <Route path={"dispatch-history"} element={<DispatchHistory />} />
        <Route path={"dispatch-history/:id"} element={<TripInformation />} />
      </Routes>
    </>
  );
};

export default Component;
